import "/home/runner/work/dev-daily-hub/dev-daily-hub/sentry.client.config.js";
import { init } from 'astro/virtual-modules/prefetch.js';init()